import { useCallback } from "react";
import PromotionCardGroupContainer from "../vas/promotionCard/PromotionCardGroupContainer";
import AddonCard from "../vas/addonCard/AddonCardContainer";
import ChartContainer from "../vas/chart/ChartContainer";
import ComboPackageGroupContainer from "../vas/comboPackageGroup/ComboPackageGroupContainer";
import TextualSeparatorContainer from "../vas/textualSeparator/TextualSeparatorContainer";
import DiscountContainer from "../vas/discount/DiscountContainer";
import StickyButton from "../vas/stickyButton/StickyButton";
import Header from "../vas/Header/Header";
import InfoHeader from "../vas/infoHeader/InfoHeader";
import { Widget } from "../interfaces/ResponseTypes";
import BundlePackageGroupContainer from "../vas/bundlePackageGroup/BundlePackageGroupContainer";
import ScrollableCardGroupContainer from "../vas/scrollableCardGroup/ScrollableCardGroupContainer";
import ButtonGroupContainer from "../vas/buttonGroup/ButtonGroupContainer";

const Mapper = ({ widget }: { widget: Widget }) => {
  const { data, type } = widget;
  const selectedComp: () => JSX.Element = useCallback(() => {
    switch (type) {
      case "header":
        return <Header data={data} />;
      case "infoHeader":
        return <InfoHeader data={data} />;
      case "scrollableCardGroup":
        return <ScrollableCardGroupContainer data={data} />;
      case "promotionCard":
        return <PromotionCardGroupContainer data={data} />;
      case "addonCard":
        return <AddonCard data={data} />;
      case "meter":
        return <ChartContainer data={data} />;
      case "comboPackageGroup":
        return <ComboPackageGroupContainer data={data} />;
      case "textualSeparator":
        return <TextualSeparatorContainer data={data} />;
      case "bundlePackageGroup":
        return <BundlePackageGroupContainer data={data} />;
      case "finalizeButton":
        return <StickyButton data={data} />;
      case "discountPill":
        return <DiscountContainer data={data}/>;
        case "buttonGroup":
          return <ButtonGroupContainer data={data} />;
      // case "sticky":
      //   return <StickyButton />;
      default:
        return <></>;
    }
  }, [data, type]);
  return selectedComp();
};

export default Mapper;
